export default "__VITE_ASSET__Av4nj4Os__"